// Copyright ©️ 2025 eVolve MEP, LLC

import { Button, Combobox } from '@mantine/core';

import type { ExtraSelectProps } from './types';

export const SelectFooter = ({
  includeCloseButton,
  footer,
  closeDropdown,
}: Pick<ExtraSelectProps, 'includeCloseButton' | 'footer'> & {
  closeDropdown: () => void;
}) => {
  if (!includeCloseButton && !footer) return null;
  return (
    <Combobox.Footer>
      {footer}
      {includeCloseButton && (
        <Button fullWidth onClick={closeDropdown} variant="light">
          Done
        </Button>
      )}
    </Combobox.Footer>
  );
};
